import React, { useEffect, useState } from 'react';

import EditSVG from '../assets/svg/edit';
import {
  SVGWrapper,
  FlexRow,
  ButtonWrapper,
  GroupTitle,
  GroupTitleContainer,
  RequiredLabel
} from './css';
import CancelSVG from '../assets/svg/cancel';
import SaveSVG from '../assets/svg/save';
import { changeServiceGroup, saveServiceGroup } from './saveSchemaToDB';

export default function GroupLabel({
  groupLabel,
  offeringId,
  groupIndex,
  setSavingData,
  fullyManagedAdminData,
  setFullyManagedAdminData
}) {
  const [label, setLabel] = useState(groupLabel);
  const [editMode, setEditMode] = useState(false);

  const handleSave = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    let serviceGroupId =clonedAdminData[groupIndex].id ;
    if (label) {
        try{
        setSavingData(true);
        if(serviceGroupId)
        {
            await changeServiceGroup(serviceGroupId,{name:label,offeringId,ord:groupIndex});
        }else
        {
            serviceGroupId = await saveServiceGroup({
                offeringId,
                ord:groupIndex,
                name: label,
            });
          clonedAdminData[groupIndex].id = serviceGroupId;
          clonedAdminData[groupIndex].offeringId = offeringId;
        }
      clonedAdminData[groupIndex].name = label;
      clonedAdminData[groupIndex].isSaved = true;
      setFullyManagedAdminData(clonedAdminData);
      setEditMode(false);
    }
    catch{
        console.log("An error occured, please try again");
        setSavingData(false);
    }
    finally{
        setSavingData(false);
    }
    }
  };

  const handleCancel = () => {
    setLabel(groupLabel);
    setEditMode(false);
  };

  useEffect(() => {
    if (!groupLabel) setEditMode(true);
  }, []);

  return (
    <>
      <GroupTitleContainer>
        <FlexRow>
          {editMode ? (
            <GroupTitle>
              <FlexRow>
                {groupIndex + 1}.
                <div>
                  <input
                    type="text"
                    value={label}
                    style={{
                      color: '#242424',
                      width: '500px',
                      borderColor: label ? '#e4e4e4' : '#C12335'
                    }}
                    onChange={e => setLabel(e.target.value)}
                  />
                  {!label && <RequiredLabel>Required</RequiredLabel>}
                </div>
              </FlexRow>
            </GroupTitle>
          ) : (
            <GroupTitle>
              {groupIndex + 1}. {groupLabel}
            </GroupTitle>
          )}

          <ButtonWrapper>
            {editMode ? (
              <>
                <SVGWrapper onClick={handleCancel}>
                  <CancelSVG />
                </SVGWrapper>
                <SVGWrapper onClick={handleSave}>
                  <SaveSVG />
                </SVGWrapper>
              </>
            ) : (
              <SVGWrapper onClick={() => setEditMode(true)}>
                <EditSVG />
              </SVGWrapper>
            )}
          </ButtonWrapper>
        </FlexRow>
      </GroupTitleContainer>
    </>
  );
}
